(function () {
  if (window.__nsCheckoutFunnelInitialized) return;
  window.__nsCheckoutFunnelInitialized = true;

  const selectors = {
    offerSection: '[data-ns-checkout-offer-section]',
    offerCard: '[data-ns-checkout-offer]',
    offerInput: '[data-ns-checkout-offer-input]',
    variantPicker: '[data-ns-variant-picker]',
    variantGroup: '[data-ns-variant-group]',
    variantOption: '[data-ns-variant-option]',
    variantSelectedValue: '[data-ns-variant-selected-value]',
    variantSummaryTitle: '[data-ns-variant-summary-title]',
    variantSummaryPrice: '[data-ns-variant-summary-price]',
    checkoutTrigger: '[data-ns-checkout-trigger]',
    error: '[data-ns-checkout-error]',
    qtyInput: '[data-ns-checkout-qty-input]',
    qtyMinus: '[data-ns-checkout-qty-minus]',
    qtyPlus: '[data-ns-checkout-qty-plus]',
    freeSection: '[data-ns-free-sabers-section]',
    freeCard: '[data-ns-free-saber]',
    freeInput: '[data-ns-free-saber-input]',
    freeCount: '[data-ns-free-saber-count]',
    freeStatus: '[data-ns-free-saber-status]',
    countdown: '[data-ns-countdown]',
    countdownTime: '[data-ns-countdown-time]'
  };

  const state = {
    offerSection: null,
    selectedOffer: null,
    quantity: 1,
    busy: false
  };

  function toInt(value, fallback) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function normalizeVariantValue(value) {
    return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getQuantity(section) {
    const input = section.querySelector(selectors.qtyInput);
    return input ? toInt(input.value, 1) : 1;
  }

  function getSelectedOffer(section) {
    if (section.dataset.variantSelectionInvalid === 'true') return null;
    return section.querySelector(`${selectors.offerCard}.is-selected:not(.is-disabled)`) || section.querySelector(`${selectors.offerCard}:not(.is-disabled)`);
  }

  function setError(section, message) {
    const error = section.querySelector(selectors.error);
    if (!error) return;
    if (message) {
      error.textContent = message;
      error.classList.add('is-visible');
    } else {
      error.textContent = '';
      error.classList.remove('is-visible');
    }
  }

  function updateSticky(detail) {
    document.querySelectorAll('[data-ns-checkout-sticky]').forEach((bar) => {
      const title = bar.querySelector('[data-ns-checkout-sticky-title]');
      const price = bar.querySelector('[data-ns-checkout-sticky-price]');
      const quantity = bar.querySelector('[data-ns-checkout-sticky-quantity]');
      const trigger = bar.querySelector(selectors.checkoutTrigger);

      if (title && detail.title) title.textContent = detail.title;
      if (price && detail.price) price.textContent = detail.price;
      if (quantity) quantity.textContent = detail.quantityText;
      if (trigger) {
        if (detail.variantId) {
          trigger.dataset.stickyVariantId = detail.variantId;
        } else {
          delete trigger.dataset.stickyVariantId;
        }
        if (detail.fallbackLink) {
          trigger.dataset.stickyFallbackLink = detail.fallbackLink;
        } else {
          delete trigger.dataset.stickyFallbackLink;
        }
      }
    });
  }

  function updateVariantPickerSummary(section, card) {
    const picker = section.querySelector(selectors.variantPicker);
    if (!picker || !card) return;

    const title = picker.querySelector(selectors.variantSummaryTitle);
    const price = picker.querySelector(selectors.variantSummaryPrice);
    if (title) title.textContent = card.dataset.title || '';
    if (price) price.textContent = card.dataset.price || '';
  }

  function selectOffer(section, card) {
    if (!card) return;
    if (card.classList.contains('is-disabled')) return;
    section.querySelectorAll(selectors.offerCard).forEach((offer) => {
      const isSelected = offer === card;
      offer.classList.toggle('is-selected', isSelected);
      offer.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      const input = offer.querySelector(selectors.offerInput);
      if (input) input.checked = isSelected;
    });

    state.offerSection = section;
    state.selectedOffer = card;
    state.quantity = getQuantity(section);
    setError(section, '');
    delete section.dataset.variantSelectionInvalid;
    updateVariantPickerSummary(section, card);

    updateSticky({
      title: card.dataset.title || '',
      price: card.dataset.price || '',
      quantityText: `Qty ${state.quantity}`,
      variantId: (card.dataset.variantId || '').trim(),
      fallbackLink: (card.dataset.fallbackLink || section.dataset.fallbackLink || '').trim()
    });
  }

  function syncVariantPicker(section) {
    const picker = section.querySelector(selectors.variantPicker);
    if (!picker) return;

    const selectedOptions = {};
    picker.querySelectorAll(selectors.variantGroup).forEach((group) => {
      const checked = group.querySelector(`${selectors.variantOption}:checked`);
      const position = group.dataset.optionPosition;
      const selectedValue = group.querySelector(selectors.variantSelectedValue);
      if (!checked || !position) return;

      selectedOptions[position] = checked.value;
      if (selectedValue) selectedValue.textContent = checked.value;
    });

    const cards = Array.from(section.querySelectorAll(selectors.offerCard));
    const orderedPositions = Object.keys(selectedOptions).sort((left, right) => Number(left) - Number(right));
    const selectedTitle = orderedPositions.map((position) => selectedOptions[position]).join(' / ');
    const matchingCard = cards.find((card) => orderedPositions.every((position) => {
      return normalizeVariantValue(card.dataset[`option${position}`]) === normalizeVariantValue(selectedOptions[position]);
    })) || cards.find((card) => {
      return normalizeVariantValue(card.dataset.title) === normalizeVariantValue(selectedTitle);
    });

    if (matchingCard && !matchingCard.classList.contains('is-disabled') && matchingCard.dataset.variantId) {
      selectOffer(section, matchingCard);
      return;
    }

    section.dataset.variantSelectionInvalid = 'true';
    cards.forEach((card) => {
      card.classList.remove('is-selected');
      card.setAttribute('aria-checked', 'false');
      const input = card.querySelector(selectors.offerInput);
      if (input) input.checked = false;
    });

    const title = picker.querySelector(selectors.variantSummaryTitle);
    const price = picker.querySelector(selectors.variantSummaryPrice);
    const optionTitle = selectedTitle;
    if (title) title.textContent = optionTitle;
    if (price) price.textContent = section.dataset.soldOutText || 'Sold out';

    if (state.offerSection === section) state.selectedOffer = null;
    setError(section, 'This variant is unavailable. Please choose another option.');
    updateSticky({
      title: optionTitle,
      price: section.dataset.soldOutText || 'Sold out',
      quantityText: `Qty ${getQuantity(section)}`,
      variantId: '',
      fallbackLink: ''
    });
  }

  function initVariantPicker(section) {
    const picker = section.querySelector(selectors.variantPicker);
    if (!picker) return;

    picker.querySelectorAll(selectors.variantOption).forEach((input) => {
      input.addEventListener('change', () => syncVariantPicker(section));
    });
    syncVariantPicker(section);
  }

  function syncQuantity(section, value) {
    const input = section.querySelector(selectors.qtyInput);
    const quantity = Math.max(1, Math.min(99, toInt(value, 1)));
    if (input) input.value = quantity;
    state.quantity = quantity;

    const card = getSelectedOffer(section);
    if (card) {
      updateSticky({
        title: card.dataset.title || '',
        price: card.dataset.price || '',
        quantityText: `Qty ${quantity}`,
        variantId: (card.dataset.variantId || '').trim(),
        fallbackLink: (card.dataset.fallbackLink || section.dataset.fallbackLink || '').trim()
      });
    }
  }

  function getActiveSection() {
    if (state.offerSection && document.body.contains(state.offerSection)) return state.offerSection;
    return document.querySelector(selectors.offerSection);
  }

  function getFreeSection() {
    return document.querySelector(selectors.freeSection);
  }

  function getFreeSelections() {
    const section = getFreeSection();
    if (!section) {
      return {
        section: null,
        required: false,
        limit: 0,
        selections: []
      };
    }

    const limit = toInt(section.dataset.limit, 2);
    const required = section.dataset.required === 'true';
    const selections = Array.from(section.querySelectorAll(`${selectors.freeCard}.is-selected`)).slice(0, limit).map((card) => ({
      title: card.dataset.title || '',
      variantId: (card.dataset.variantId || '').trim()
    }));

    return { section, required, limit, selections };
  }

  function getCheckoutContext(trigger) {
    const section = getActiveSection();
    if (!section) {
      return {
        section: null,
        offer: trigger,
        variantId: (trigger.dataset.stickyVariantId || '').trim(),
        fallbackLink: (trigger.dataset.stickyFallbackLink || '').trim(),
        quantity: 1,
        clearCart: false,
        checkoutUrl: '/checkout',
        errorMessage: 'Please select an available Ani EP3 option.',
        freeSabers: getFreeSelections()
      };
    }

    const offer = getSelectedOffer(section);
    const quantity = getQuantity(section);
    const multiplier = offer ? toInt(offer.dataset.quantityMultiplier, 1) : 1;

    return {
      section,
      offer,
      variantId: offer ? (offer.dataset.variantId || '').trim() : '',
      fallbackLink: offer ? (offer.dataset.fallbackLink || section.dataset.fallbackLink || '').trim() : (section.dataset.fallbackLink || '').trim(),
      quantity: quantity * multiplier,
      clearCart: section.dataset.clearCart === 'true',
      checkoutUrl: section.dataset.checkoutUrl || '/checkout',
      errorMessage: section.dataset.errorMessage || 'Please select an available Ani EP3 option.',
      freeSabers: getFreeSelections()
    };
  }

  async function postJson(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: body ? JSON.stringify(body) : undefined
    });

    if (!response.ok) {
      let message = 'Unable to prepare checkout. Please try again.';
      try {
        const payload = await response.json();
        message = payload.description || payload.message || message;
      } catch (error) {
        message = response.statusText || message;
      }
      throw new Error(message);
    }

    return response.json();
  }

  async function postForm(url, item) {
    const body = new URLSearchParams();
    body.set('id', String(item.id));
    body.set('quantity', String(item.quantity || 1));
    Object.entries(item.properties || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        body.set(`properties[${key}]`, String(value));
      }
    });

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body
    });

    if (!response.ok) {
      let message = 'Unable to prepare checkout. Please try again.';
      try {
        const payload = await response.json();
        message = payload.description || payload.message || message;
      } catch (error) {
        message = response.statusText || message;
      }
      throw new Error(message);
    }

    return response.json();
  }

  async function addCartItem(item) {
    try {
      return await postJson('/cart/add.js', { items: [item] });
    } catch (jsonError) {
      return postForm('/cart/add.js', item);
    }
  }

  async function addCartItems(items) {
    try {
      return await postJson('/cart/add.js', { items });
    } catch (jsonError) {
      for (const item of items) {
        await postForm('/cart/add.js', item);
      }
    }
  }

  async function getCart() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    const cartUrl = `${root}cart.js`;

    for (let attempt = 0; attempt < 3; attempt += 1) {
      try {
        const response = await fetch(cartUrl, {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        });

        if (response.ok) return response.json();

        const canRetry = response.status === 429 || response.status >= 500;
        if (!canRetry || attempt === 2) break;

        const retryAfter = Number(response.headers.get('retry-after') || 0) * 1000;
        await wait(retryAfter || 800 * (attempt + 1));
      } catch (error) {
        if (attempt === 2) break;
        await wait(800 * (attempt + 1));
      }
    }

    throw new Error('Unable to verify cart. Please try again.');
  }

  function getLineBundleToken(lineItem) {
    const properties = lineItem && lineItem.properties ? lineItem.properties : {};
    return String(properties['_NS bundle'] || '');
  }

  function getCartFreeGiftLine(cart, item, bundleToken) {
    return (cart.items || []).find((lineItem) => {
      const properties = lineItem.properties || {};
      return Number(lineItem.variant_id) === Number(item.id)
        && properties['_NS free gift'] === 'true'
        && getLineBundleToken(lineItem) === bundleToken;
    });
  }

  function cartHasMainOffer(cart, item, bundleToken) {
    return (cart.items || []).some((lineItem) => {
      const properties = lineItem.properties || {};
      return Number(lineItem.variant_id) === Number(item.id)
        && properties['_NS funnel offer'] === 'true'
        && properties['_NS free gift'] !== 'true'
        && getLineBundleToken(lineItem) === bundleToken;
    });
  }

  function isFunnelLine(lineItem) {
    const properties = lineItem.properties || {};
    return properties['_NS funnel offer'] === 'true'
      || properties['_NS free gift'] === 'true'
      || (properties['_Selected offer'] && properties['_Offer includes']);
  }

  function normalizeDiscountName(value) {
    return String(value || '').trim().toUpperCase();
  }

  function lineHasAppliedDiscount(lineItem, discountName) {
    const expectedName = normalizeDiscountName(discountName);
    const itemDiscounts = Array.isArray(lineItem.discounts) ? lineItem.discounts : [];
    const allocations = Array.isArray(lineItem.line_level_discount_allocations)
      ? lineItem.line_level_discount_allocations
      : [];

    const itemDiscountMatches = itemDiscounts.some((discount) => {
      const name = normalizeDiscountName(discount.title || discount.code);
      const amount = Number(discount.amount || discount.discounted_amount || 0);
      return name === expectedName && amount > 0;
    });
    if (itemDiscountMatches) return true;

    return allocations.some((allocation) => {
      const application = allocation.discount_application || {};
      const name = normalizeDiscountName(application.title || application.code);
      const amount = Number(allocation.amount || allocation.discounted_amount || 0);
      return name === expectedName && amount > 0;
    });
  }

  function isConflictingPromotionGift(lineItem) {
    const properties = lineItem.properties || {};
    return properties['_B1G3 gift'] === 'true'
      || (properties['_NS free gift'] !== 'true' && lineHasAppliedDiscount(lineItem, 'FREE'));
  }

  function remainingDiscountCodes(cart) {
    return (cart.discount_codes || [])
      .map((discount) => discount.code || discount.title || '')
      .filter((code) => code && normalizeDiscountName(code) !== 'B1G3');
  }

  function cartHasDiscountCode(cart, discountCode) {
    const expectedCode = normalizeDiscountName(discountCode);
    return (cart.discount_codes || []).some((discount) => {
      return normalizeDiscountName(discount.code || discount.title) === expectedCode;
    });
  }

  function freeGiftLineIsDiscounted(lineItem) {
    if (!lineItem) return false;
    const originalLinePrice = Number(lineItem.original_line_price ?? lineItem.line_price ?? 0);
    const finalLinePrice = Number(lineItem.final_line_price ?? lineItem.line_price ?? 0);
    return originalLinePrice > 0 && finalLinePrice === 0;
  }

  function wait(milliseconds) {
    return new Promise((resolve) => window.setTimeout(resolve, milliseconds));
  }

  function allFunnelGiftsAreFree(cart) {
    const giftLines = (cart.items || []).filter((lineItem) => {
      const properties = lineItem.properties || {};
      return properties['_NS free gift'] === 'true';
    });
    return giftLines.length > 0 && giftLines.every(freeGiftLineIsDiscounted);
  }

  function cartHasExactPreparedBundle(cart, mainItem, freeGiftItems, bundleToken) {
    const funnelLines = (cart.items || []).filter((lineItem) => {
      return isFunnelLine(lineItem) && getLineBundleToken(lineItem) === bundleToken;
    });
    const mainLines = funnelLines.filter((lineItem) => {
      const properties = lineItem.properties || {};
      return properties['_NS funnel offer'] === 'true' && properties['_NS free gift'] !== 'true';
    });
    const giftLines = funnelLines.filter((lineItem) => {
      const properties = lineItem.properties || {};
      return properties['_NS free gift'] === 'true';
    });

    if (mainLines.length !== 1 || giftLines.length !== freeGiftItems.length) return false;
    if (Number(mainLines[0].variant_id) !== Number(mainItem.id)) return false;
    if (Number(mainLines[0].quantity) !== Number(mainItem.quantity)) return false;

    const unmatchedGiftLines = giftLines.slice();
    for (const giftItem of freeGiftItems) {
      const matchingIndex = unmatchedGiftLines.findIndex((lineItem) => {
        return Number(lineItem.variant_id) === Number(giftItem.id)
          && Number(lineItem.quantity) === Number(giftItem.quantity || 1)
          && freeGiftLineIsDiscounted(lineItem);
      });
      if (matchingIndex === -1) return false;
      unmatchedGiftLines.splice(matchingIndex, 1);
    }

    return unmatchedGiftLines.length === 0 && allFunnelGiftsAreFree(cart);
  }

  async function removeConflictingPromotionItems(knownCart, mainItem, bundleToken, rollbackOnly) {
    const cart = knownCart || await getCart();
    const hasMatchingLegacyMain = !rollbackOnly && (cart.items || []).some((lineItem) => {
      const properties = lineItem.properties || {};
      return Number(lineItem.variant_id) === Number(mainItem.id)
        && properties['_NS funnel offer'] === 'true'
        && properties['_NS free gift'] !== 'true'
        && !getLineBundleToken(lineItem);
    });
    const oldPromotionLines = (cart.items || []).filter((lineItem) => {
      const lineBundleToken = getLineBundleToken(lineItem);
      if (lineBundleToken && lineBundleToken === bundleToken) return true;
      if (rollbackOnly) return false;
      if (hasMatchingLegacyMain && isFunnelLine(lineItem) && !lineBundleToken) return true;
      return isConflictingPromotionGift(lineItem);
    });

    const updates = {};
    oldPromotionLines.forEach((lineItem) => {
      const lineId = lineItem.key || lineItem.id || lineItem.variant_id;
      if (lineId) updates[lineId] = 0;
    });

    const payload = {};
    if (Object.keys(updates).length) payload.updates = updates;
    if (!rollbackOnly && cartHasDiscountCode(cart, 'B1G3')) {
      payload.discount = remainingDiscountCodes(cart).join(',');
    }

    if (Object.keys(payload).length) {
      await postJson('/cart/update.js', payload);
    }
  }

  function buildPreparedItems(context) {
    const bundleToken = `NS-FREE-${context.variantId}`;
    const properties = {
      '_NS funnel offer': 'true',
      '_NS bundle': bundleToken
    };
    if (context.offer.dataset.title) {
      properties['_Selected offer'] = context.offer.dataset.title;
    }

    const freeSabers = context.freeSabers || { selections: [], limit: 0 };
    const freeSaberTitles = [];
    freeSabers.selections.forEach((selection, index) => {
      if (selection.title) {
        freeSaberTitles.push(selection.title);
        properties[`_Free saber ${index + 1}`] = selection.title;
      }
    });
    if (freeSaberTitles.length) {
      properties['_Free saber choices'] = freeSaberTitles.join(' + ');
    }
    if (freeSabers.limit > 0) {
      properties['_Offer includes'] = `${freeSabers.limit} free saber choices`;
    }

    const mainItem = {
      id: Number(context.variantId),
      quantity: context.quantity,
      properties
    };
    const freeGiftItems = freeSabers.selections.map((selection, index) => ({
      id: Number(selection.variantId),
      quantity: 1,
      properties: {
        '_Free gift with': context.offer.dataset.title || 'Selected offer',
        '_Free gift number': String(index + 1),
        '_NS free gift': 'true',
        '_NS funnel offer': 'true',
        '_NS bundle': bundleToken,
        '_NS main variant': String(context.variantId)
      }
    }));

    return { mainItem, freeGiftItems, bundleToken };
  }

  async function verifyPreparedCart(mainItem, freeGiftItems, bundleToken) {
    let cart = null;

    for (let attempt = 0; attempt < 8; attempt += 1) {
      cart = await getCart();
      const mainOfferIsPresent = cartHasMainOffer(cart, mainItem, bundleToken);
      const giftLines = freeGiftItems.map((item) => getCartFreeGiftLine(cart, item, bundleToken));
      const giftsArePresent = giftLines.every(Boolean);
      const giftsAreFree = giftLines.every(freeGiftLineIsDiscounted);
      const everyFunnelGiftIsFree = allFunnelGiftsAreFree(cart);

      if (mainOfferIsPresent && giftsArePresent && giftsAreFree && everyFunnelGiftIsFree) return cart;
      if (attempt < 7) await wait(Math.min(500 + (attempt * 300), 2000));
    }

    const missingGift = freeGiftItems.find((item) => !getCartFreeGiftLine(cart || {}, item, bundleToken));
    if (missingGift) {
      throw new Error('One selected free saber could not be added. Please try again.');
    }

    throw new Error('Your two free sabers were added, but the automatic FREE discount did not apply. Checkout has been paused so you are not charged for them. Please try again or contact us.');
  }

  async function handleCheckout(event) {
    const trigger = event.target.closest(selectors.checkoutTrigger);
    if (!trigger) return;

    event.preventDefault();
    if (state.busy) return;

    const context = getCheckoutContext(trigger);
    if (!context || !context.offer) return;

    if (!context.variantId) {
      if (context.fallbackLink) {
        window.location.href = context.fallbackLink;
        return;
      }
      if (context.section) setError(context.section, context.errorMessage);
      return;
    }

    if (!/^\d+$/.test(context.variantId)) {
      if (context.section) setError(context.section, context.errorMessage);
      return;
    }

    if (context.freeSabers && context.freeSabers.required && context.freeSabers.selections.length < context.freeSabers.limit) {
      if (context.section) {
        setError(context.section, `Please select ${context.freeSabers.limit} free sabers before checkout.`);
      }
      if (context.freeSabers.section) {
        context.freeSabers.section.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    const invalidFreeSabers = (context.freeSabers ? context.freeSabers.selections : []).filter((selection) => !/^\d+$/.test(selection.variantId));
    if (invalidFreeSabers.length) {
      if (context.section) {
        setError(context.section, 'One selected free saber is missing a variant. Please choose another free saber or contact us.');
      }
      if (context.freeSabers && context.freeSabers.section) {
        context.freeSabers.section.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    if (context.section) setError(context.section, '');
    state.busy = true;
    const triggers = Array.from(document.querySelectorAll(selectors.checkoutTrigger));
    triggers.forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });

    const preparedItems = buildPreparedItems(context);
    const mainItem = preparedItems.mainItem;
    const freeGiftItems = preparedItems.freeGiftItems;
    const bundleToken = preparedItems.bundleToken;
    let cartMutationStarted = false;

    try {
      const existingCart = await getCart();
      if (cartHasExactPreparedBundle(existingCart, mainItem, freeGiftItems, bundleToken)) {
        window.location.href = context.checkoutUrl;
        return;
      }

      cartMutationStarted = true;
      if (context.clearCart) {
        await postJson('/cart/clear.js');
      } else {
        await removeConflictingPromotionItems(existingCart, mainItem, bundleToken, false);
      }

      await addCartItems([mainItem].concat(freeGiftItems));
      await verifyPreparedCart(mainItem, freeGiftItems, bundleToken);

      window.location.href = context.checkoutUrl;
    } catch (error) {
      if (cartMutationStarted) {
        try {
          await removeConflictingPromotionItems(null, mainItem, bundleToken, true);
        } catch (cleanupError) {
          // Preserve the original checkout error while avoiding another customer-facing failure.
        }
      }
      if (context.section) setError(context.section, error.message || 'Unable to prepare checkout. Please try again.');
      triggers.forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
      state.busy = false;
    }
  }

  function initOfferSections() {
    document.querySelectorAll(selectors.offerSection).forEach((section) => {
      const cards = Array.from(section.querySelectorAll(selectors.offerCard));
      if (!cards.length) return;

      cards.forEach((card) => {
        card.addEventListener('click', () => selectOffer(section, card));
        const input = card.querySelector(selectors.offerInput);
        if (input) {
          input.addEventListener('change', () => selectOffer(section, card));
        }
      });

      const selected = cards.find((card) => card.classList.contains('is-selected') && !card.classList.contains('is-disabled')) || cards.find((card) => !card.classList.contains('is-disabled')) || cards[0];
      selectOffer(section, selected);
      initVariantPicker(section);

      const input = section.querySelector(selectors.qtyInput);
      if (input) {
        input.addEventListener('change', () => syncQuantity(section, input.value));
        input.addEventListener('input', () => syncQuantity(section, input.value));
      }

      const minus = section.querySelector(selectors.qtyMinus);
      if (minus) {
        minus.addEventListener('click', () => syncQuantity(section, getQuantity(section) - 1));
      }

      const plus = section.querySelector(selectors.qtyPlus);
      if (plus) {
        plus.addEventListener('click', () => syncQuantity(section, getQuantity(section) + 1));
      }
    });
  }

  function updateFreeCount(section) {
    const count = section.querySelectorAll(`${selectors.freeCard}.is-selected`).length;
    const limit = toInt(section.dataset.limit, 2);
    const countEl = section.querySelector(selectors.freeCount);
    const statusEl = section.querySelector(selectors.freeStatus);
    const isComplete = count === limit;

    if (countEl) countEl.textContent = `${count}/${limit} selected`;
    if (statusEl) {
      statusEl.textContent = isComplete
        ? 'Both gifts selected. Their automatic discount will be verified before checkout.'
        : `Select ${limit - count} more free saber${limit - count === 1 ? '' : 's'} to continue.`;
    }
    section.classList.toggle('is-complete', isComplete);
  }

  function initFreeSaberSections() {
    document.querySelectorAll(selectors.freeSection).forEach((section) => {
      const limit = toInt(section.dataset.limit, 2);
      section.querySelectorAll(selectors.freeCard).forEach((card) => {
        card.addEventListener('click', (event) => {
          event.preventDefault();
          const selected = card.classList.contains('is-selected');
          const current = section.querySelectorAll(`${selectors.freeCard}.is-selected`).length;
          if (!selected && current >= limit) return;

          card.classList.toggle('is-selected', !selected);
          card.setAttribute('aria-pressed', selected ? 'false' : 'true');
          const input = card.querySelector(selectors.freeInput);
          if (input) input.checked = !selected;
          updateFreeCount(section);
        });
      });
      updateFreeCount(section);
    });
  }

  function initCountdowns() {
    document.querySelectorAll(selectors.countdown).forEach((countdown) => {
      if (countdown.dataset.initialized === 'true') return;
      countdown.dataset.initialized = 'true';

      const duration = toInt(countdown.dataset.duration, 20 * 60) * 1000;
      const storageKey = countdown.dataset.storageKey || 'ns-free-saber-countdown';
      const timeEl = countdown.querySelector(selectors.countdownTime);
      let deadline = Date.now() + duration;

      try {
        const storedDeadline = Number(window.sessionStorage.getItem(storageKey));
        if (Number.isFinite(storedDeadline) && storedDeadline > 0) deadline = storedDeadline;
      } catch (error) {
        // The countdown still runs when browser storage is unavailable.
      }

      function storeDeadline() {
        try {
          window.sessionStorage.setItem(storageKey, String(deadline));
        } catch (error) {
          // The in-memory deadline remains active for this page view.
        }
      }

      function renderCountdown() {
        const now = Date.now();
        if (deadline <= now) {
          const completedLoops = Math.floor((now - deadline) / duration) + 1;
          deadline += completedLoops * duration;
          storeDeadline();
        }

        const secondsRemaining = Math.max(0, Math.ceil((deadline - now) / 1000));
        const minutes = Math.floor(secondsRemaining / 60);
        const seconds = secondsRemaining % 60;
        if (timeEl) timeEl.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }

      storeDeadline();
      renderCountdown();
      window.setInterval(renderCountdown, 1000);
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-ns-checkout-faq-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
      });
    });
  }

  function initStickyHide() {
    let lastY = window.scrollY;
    document.querySelectorAll('[data-ns-checkout-sticky][data-hide-on-scroll="true"]').forEach((bar) => {
      window.addEventListener('scroll', () => {
        const currentY = window.scrollY;
        bar.classList.toggle('is-hidden', currentY > lastY && currentY > 120);
        lastY = currentY;
      }, { passive: true });
    });
  }

  document.addEventListener('click', handleCheckout);
  document.addEventListener('DOMContentLoaded', () => {
    initOfferSections();
    initFreeSaberSections();
    initCountdowns();
    initFaq();
    initStickyHide();
  });
})();
